import { api } from './api'

export const markAsUnreserved = ({ itemId }: { itemId: number }) =>
  api.delete(`items/${itemId}/reservation`)
